import { MembershipPage } from '@/components/MembershipPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(
  MembershipPage,
  {
    requiresEvery: [RouteRestrictions.AUTHENTICATION],
  },
  { requiresMemberManagement: true }
);
